<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
    :disabledCheckbox="true"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "questionnaires",
      pk: "id",
      columns: [
        {
          value: "id",
          text: "アンケートID",
          filter: true,
          width: '80px'
        },
        {
          value: "form_title",
          text: "アンケート名",
          filter: true,
          width: 80
        },
        {
          value: "publish_from",
          text: "公開期間 from",
          filter: true,
          type: "date",
          width: 80
        },
        {
          value: "publish_to",
          text: "公開期間 to",
          filter: true,
          type: "date",
          width: 80
        },
        {
          value: "description",
          text: "概要",
          filter: true,
          width: 80
        },
        {
          value: "publish",
          text: "公開/非公開",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/publish"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "アンケート一覧",
          disabled: true
        }
      ];
    }
  }
};
</script>
